import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// MUI

// Constants
import { MS_API_BASE_URL, MS_API_CDN_URL, MS_API_AZURE_URL_BUYER, MS_API_AZURE_URL_SELLER, roles } from '../configurations/settings';

//interfaces

//libs
import axios from 'axios';
import i18n from '../i18n';
var isEmpty = function isEmpty(obj) {
  if (obj) {
    if (typeof obj === 'string') {
      return obj.trim().length === 0;
    } else if (_typeof(obj) === 'object' && Object.keys(obj).length > 0) {
      return false;
    }
  }
  return true;
};
var filterCountryCodeFields = function filterCountryCodeFields(fieldItem, countryCode) {
  var _fieldItem$countryCod, _fieldItem$countryCod2;
  return ((_fieldItem$countryCod = fieldItem.countryCodeFields) === null || _fieldItem$countryCod === void 0 ? void 0 : _fieldItem$countryCod.length) === 0 || ((_fieldItem$countryCod2 = fieldItem.countryCodeFields) === null || _fieldItem$countryCod2 === void 0 ? void 0 : _fieldItem$countryCod2.includes(String(countryCode)));
};
var getCountrySpecificFields = function getCountrySpecificFields(displaySections, countryCode) {
  var tempInfoSection = getCountrySpecificSections(displaySections, countryCode);
  tempInfoSection === null || tempInfoSection === void 0 || tempInfoSection.forEach(function (section, index) {
    var _section$fields;
    var tempInfoSectionFields = [];
    (_section$fields = section.fields) === null || _section$fields === void 0 || _section$fields.forEach(function (innerItem) {
      if (countryCode) {
        if (Array.isArray(innerItem)) {
          if (innerItem.filter(function (fieldItem) {
            return filterCountryCodeFields(fieldItem, countryCode);
          }).length > 0) {
            tempInfoSectionFields.push(innerItem.filter(function (fieldItem) {
              return filterCountryCodeFields(fieldItem, countryCode);
            }));
          }
        } else {
          if (filterCountryCodeFields(innerItem, countryCode)) tempInfoSectionFields.push(innerItem);
        }
      }
    });
    tempInfoSection[index].fields = (tempInfoSectionFields === null || tempInfoSectionFields === void 0 ? void 0 : tempInfoSectionFields.length) > 0 ? tempInfoSectionFields : section.fields;
  });
  return tempInfoSection;
};
var getCountrySpecificSections = function getCountrySpecificSections(displaySections, countryCode) {
  var tempInfoSection = displaySections.map(function (object) {
    return _objectSpread({}, object);
  });
  //To remove the section not relevent based on the country code.
  tempInfoSection === null || tempInfoSection === void 0 || tempInfoSection.forEach(function (section, index) {
    if (section.countrySpecific && section.countrySpecific.length > 0 && countryCode) {
      if (!section.countrySpecific.includes(countryCode)) {
        tempInfoSection.splice(index, 1);
      }
    }
  });
  return tempInfoSection;
};
var getCountrySpecificDocuments = function getCountrySpecificDocuments(displaySections, countryCode) {
  var _getCountrySpecificSe;
  var tempInfoSection = getCountrySpecificSections(displaySections, countryCode);
  (_getCountrySpecificSe = getCountrySpecificSections(displaySections, countryCode)) === null || _getCountrySpecificSe === void 0 || _getCountrySpecificSe.forEach(function (section, outerIndex) {
    var tempDocumentTypes = [];
    if (section.documents && section.documents.length > 0) {
      var _section$documents;
      (_section$documents = section.documents) === null || _section$documents === void 0 || _section$documents.forEach(function (document) {
        var _document$countryCode;
        if (!document.countryCodeFields || countryCode && (_document$countryCode = document.countryCodeFields) !== null && _document$countryCode !== void 0 && _document$countryCode.includes(countryCode)) {
          tempDocumentTypes.push(document);
        }
      });
      tempInfoSection[outerIndex].documents = tempDocumentTypes;
    }
  });
  return tempInfoSection;
};
var getAttributeProperty = function getAttributeProperty(fieldItem, attributeName) {
  switch (attributeName) {
    case 'disabled':
      return fieldItem.disabled;
    case 'isVisible':
      return fieldItem.isVisible;
    case 'mandatory':
      return fieldItem.mandatory;
    default:
      return false;
  }
};
var getAttributeFlag = function getAttributeFlag(item, fieldName, fieldValue, attributeName) {
  var disableFlag = getAttributeProperty(item, attributeName);
  if (item.parentField && item.parentField === fieldName && (fieldValue === 'yes' || fieldValue !== '' && fieldValue !== 'no')) {
    disableFlag = false;
  } else if (item.parentField && item.parentField === fieldName && (fieldValue === '' || fieldValue !== 'yes')) {
    disableFlag = true;
  }
  return disableFlag;
};
var checkForModification = function checkForModification(fieldItem, fieldName, attributeName) {
  var _fieldItem$dependantA;
  if (fieldItem !== null && fieldItem !== void 0 && fieldItem.dependantAttributes && attributeName) return fieldItem.parentField === fieldName && (fieldItem === null || fieldItem === void 0 || (_fieldItem$dependantA = fieldItem.dependantAttributes) === null || _fieldItem$dependantA === void 0 ? void 0 : _fieldItem$dependantA.includes(attributeName));else return fieldItem.parentField === fieldName;
};
var getValidationMessage = function getValidationMessage(fieldLabel) {
  switch (fieldLabel) {
    case 'REGISTRATION.IF_YES_PLEASE_ENTER_MSME_NO':
      return i18n.t('REGISTRATION.IF_YES_PLEASE_ENTER_MSME_NO_VALIDATION');
    case 'REGISTRATION.POSTAL_CODE_US':
      return i18n.t('REGISTRATION.POSTAL_CODE_US_VALIDATION');
    case 'REGISTRATION.PAN_FULL_NAME':
      return i18n.t('REGISTRATION.PAN_FULL_NAME_VALIDATION');
    default:
      return i18n.t(fieldLabel);
  }
};
var modifyFieldAttributes = function modifyFieldAttributes(fieldName, fieldValue, attributeName, invalidFlag, validationMessage, fieldItem) {
  if (attributeName === 'disabled') fieldItem.disabled = checkForModification(fieldItem, fieldName, attributeName) ? getAttributeFlag(fieldItem, fieldName, fieldValue, attributeName) : fieldItem.disabled;else if (attributeName === 'isVisible') fieldItem.isVisible = checkForModification(fieldItem, fieldName, attributeName) ? !getAttributeFlag(fieldItem, fieldName, fieldValue, attributeName) : fieldItem.isVisible;else if (attributeName === 'mandatory') fieldItem.mandatory = checkForModification(fieldItem, fieldName, attributeName) ? !getAttributeFlag(fieldItem, fieldName, fieldValue, attributeName) : fieldItem.mandatory;else if (invalidFlag === true && fieldItem.fieldName === fieldName) {
    fieldItem.fieldError = fieldValue ? validationMessage : '';
  } else if (invalidFlag === false && fieldItem.fieldName === fieldName) {
    fieldItem.fieldError = '';
  }
  return fieldItem;
};

/*
1. fieldName - the actual field name where the I/O operations are in place  or the field for which validation has to be checked.
2. fieldValue -  value of that particular field
3. attributeName - specifies which particular attribute has to be modified or if attribute name is not specified, it will be checked for validation errors.
4. invalidFlag - To set/clear the validation messages against each field. (it will be checked only when attributeName is sent as empty string)
5. validationMessage - Displays the proper message for each field.
6. fieldsState - list of fields w.r.t country selection
*/
var modifyFields = function modifyFields(fieldName, fieldValue, attributeName, invalidFlag, validationMessage, fieldsState) {
  var tempInfoFields = _toConsumableArray(fieldsState);
  tempInfoFields.forEach(function (item) {
    item.fields.forEach(function (innerItem) {
      if (!Array.isArray(innerItem)) {
        modifyFieldAttributes(fieldName, fieldValue, attributeName, invalidFlag, validationMessage, innerItem);
      } else {
        innerItem.forEach(function (fieldItem) {
          modifyFieldAttributes(fieldName, fieldValue, attributeName, invalidFlag, validationMessage, fieldItem);
        });
      }
    });
  });
  return tempInfoFields;
};
var getAPIBaseURL = function getAPIBaseURL(environment) {
  switch (environment) {
    case 'development':
      return MS_API_BASE_URL.DEVELOPMENT;
    case 'qa':
      return MS_API_BASE_URL.QA;
    case 'qa-internal':
      return MS_API_BASE_URL.QA_INTERNAL;
    case 'stage':
      return MS_API_BASE_URL.STAGE;
    case 'production':
      return MS_API_BASE_URL.PRODUCTION;
    default:
      return MS_API_BASE_URL.DEVELOPMENT;
  }
};
var getStorageLinks = function getStorageLinks(environment, role) {
  var devEnvironment = {
    cdn: MS_API_CDN_URL.DEVELOPMENT,
    azure: role === roles.BUYER_ROLE ? MS_API_AZURE_URL_BUYER.DEVELOPMENT : MS_API_AZURE_URL_SELLER.DEVELOPMENT
  };
  switch (environment) {
    case 'development':
      return devEnvironment;
    case 'qa':
      return {
        cdn: MS_API_CDN_URL.QA,
        azure: role === roles.BUYER_ROLE ? MS_API_AZURE_URL_BUYER.QA : MS_API_AZURE_URL_SELLER.QA
      };
    case 'qa-internal':
      return {
        cdn: MS_API_CDN_URL.QA_INTERNAL,
        azure: role === roles.BUYER_ROLE ? MS_API_AZURE_URL_BUYER.QA_INTERNAL : MS_API_AZURE_URL_SELLER.QA_INTERNAL
      };
    case 'stage':
      return {
        cdn: MS_API_CDN_URL.STAGE,
        azure: role === roles.BUYER_ROLE ? MS_API_AZURE_URL_BUYER.STAGE : MS_API_AZURE_URL_SELLER.STAGE
      };
    case 'production':
      return {
        cdn: MS_API_CDN_URL.PRODUCTION,
        azure: role === roles.BUYER_ROLE ? MS_API_AZURE_URL_BUYER.PRODUCTION : MS_API_AZURE_URL_SELLER.PRODUCTION
      };
    default:
      return devEnvironment;
  }
};

/* istanbul ignore next */
var getThemeOptions = function getThemeOptions(fontName, configOptions) {
  var fontFamilyNames = 'boschsans,Roboto,Helvetica,Arial,sans-serif';
  var finalFontName = "".concat(fontName ? fontName : fontFamilyNames, " !important");
  return {
    palette: {
      primary: {
        main: '#007BC0',
        contrastText: '#fff' //default even if we dont specify
      },
      secondary: {
        dark: '#8a9097',
        main: '#ffffff',
        light: '#eff1f2',
        contrastText: '#fff' //default even if we dont specify
      },
      text: {
        primary: '#000',
        secondary: '#0009'
      },
      error: {
        main: '#ED0007',
        light: '#ff8787'
      }
    },
    typography: {
      fontFamily: finalFontName,
      subtitle1: {
        fontWeight: 'bold',
        fontSize: '16px'
      }
    },
    components: {
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontFamily: finalFontName,
            fontSize: '0.75rem',
            color: '#000'
          }
        },
        variants: [{
          props: {
            variant: 'outlined'
          },
          style: {
            transform: 'none !important',
            position: 'relative'
          }
        }]
      },
      MuiFilledInput: {
        styleOverrides: {
          root: {
            '& .MuiInputBase-formControl': {
              height: '60px !important'
            }
          }
        }
      },
      MuiButton: {
        variants: [{
          props: {
            variant: 'contained'
          },
          style: {
            fontFamily: finalFontName,
            color: 'white !important',
            backgroundColor: '#007bc0 !important',
            borderRadius: '0 !important',
            textTransform: 'capitalize',
            border: '0px !important',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#00629a !important'
            },
            '&:disabled': {
              opacity: '0.4 !important'
            }
          }
        }, {
          props: {
            variant: 'outlined'
          },
          style: {
            fontFamily: finalFontName,
            color: '#007bc0',
            textTransform: 'capitalize',
            borderRadius: '0 !important',
            border: '1px #007bc0 solid !important',
            '&:disabled': {
              opacity: '0.4 !important'
            }
          }
        }, {
          props: {
            variant: 'text'
          },
          style: {
            border: 'none !important',
            background: 'none !important',
            color: '#007bc0',
            fontFamily: finalFontName,
            fontSize: '1em !important',
            textTransform: 'none',
            paddingLeft: '0 !important',
            borderRadius: '0 !important',
            '&:disabled': {
              opacity: '0.4 !important'
            }
          }
        }]
      },
      MuiTextField: {
        defaultProps: {
          variant: 'filled',
          fullWidth: true
        },
        styleOverrides: {
          root: {
            fontFamily: finalFontName,
            '&.Mui-disabled': {
              backgroundColor: '#EFF1F2'
            },
            '& ::placeholder': {
              fontSize: '0.8rem !important'
            },
            '&.search-field': {
              '& .MuiInputBase-input': {
                paddingTop: '10px !important',
                paddingBottom: '10px !important',
                paddingLeft: '10px',
                borderRadius: '0 !important',
                paddingRight: '0 !important'
              }
            },
            '&.user-input-field': {
              '& label': {
                color: 'black',
                fontSize: '14px !important',
                zIndex: 1,
                paddingLeft: '15px !important',
                paddingTop: '30px !important'
              },
              '& .MuiInputBase-input': {
                paddingLeft: '0.8rem !important',
                fontSize: '1rem !important'
              },
              '& .MuiInputBase-formControl': {
                width: 'auto',
                textOverflow: 'ellipsis',
                border: 'none',
                borderBottom: '1px solid black',
                height: '50px',
                padding: '15px',
                paddingLeft: 0,
                paddingTop: '30px',
                backgroundColor: '#e0e2e5 !important'
              },
              '& .MuiFilledInput-root:before': {
                borderBottom: 'none'
              },
              '& .MuiFilledInput-root:after': {
                border: 'none !important'
              },
              '& .MuiInput-underline:after': {
                border: 'none !important'
              },
              '& .MuiInput-underline:before': {
                border: 'none !important'
              },
              '& .MuiInputBase-formControl:hover': {
                backgroundColor: '#c1c7cc !important'
              },
              '& .MuiInput-root.Mui-focused': {
                backgroundColor: '#d1e4ff !important'
              }
            },
            '&.user-input-select-field': {
              marginTop: '16px !important',
              '& label': {
                color: 'black',
                fontSize: '14px !important',
                zIndex: 1
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: 'black !important'
              },
              '& select:focus ': {
                borderRadius: '4px'
              },
              '& select:hover ': {
                borderBottom: '1px solid #015 !important'
              },
              '& option': {
                backgroundColor: '#c1c7cc !important'
              },
              '& .MuiInputBase-input': {
                paddingLeft: '10px !important'
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: 'Black'
              },
              '& .MuiFilledInput-input': {
                height: '36px',
                paddingTop: '10px !important'
              },
              '& .MuiFilledInput-root:before': {
                borderBottom: 'none'
              },
              '& .MuiFilledInput-root:after': {
                border: 'none !important'
              },
              '& .MuiInputBase-root-MuiInput-root': {
                width: 'inherit !important'
              },
              '& .MuiFormHelperText-root': {
                marginLeft: 0
              },
              '& .MuiInputBase-formControl': {
                textOverflow: 'ellipsis',
                borderBottom: '1px solid black',
                paddingLeft: 0,
                backgroundColor: '#e0e2e5 !important',
                borderRadius: 'inherit'
              },
              '& .MuiInputBase-formControl:hover': {
                backgroundColor: '#c1c7cc !important',
                borderBottom: 'none'
              },
              '& .MuiInput-root.Mui-focused': {
                border: '2px solid #000',
                backgroundColor: '#d1e4ff !important'
              }
            }
          }
        }
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            color: 'red !important',
            fontFamily: finalFontName
          }
        }
      },
      MuiLink: {
        styleOverrides: {
          root: {
            '& :hover': {
              color: '#007BC0'
            }
          }
        }
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontFamily: finalFontName,
            textTransform: 'none'
          }
        }
      },
      MuiCssBaseline: {
        styleOverrides: {
          '::-webkit-scrollbar': {
            width: configOptions !== null && configOptions !== void 0 && configOptions.scrollBarThickness ? (configOptions === null || configOptions === void 0 ? void 0 : configOptions.scrollBarThickness) + 'px' : '3px'
          },
          '*::-webkit-scrollbar-thumb': {
            background: configOptions !== null && configOptions !== void 0 && configOptions.scrollBarColor ? configOptions === null || configOptions === void 0 ? void 0 : configOptions.scrollBarColor : '#cccecf'
          }
        }
      },
      MuiSwitch: {
        styleOverrides: {
          root: {
            width: 50,
            height: 24,
            padding: 0,
            '& .MuiSwitch-switchBase': {
              padding: 3,
              '&.Mui-checked': {
                transform: 'translateX(25px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                  opacity: 1,
                  backgroundColor: '#007bc0'
                }
              }
            },
            '& .MuiSwitch-thumb': {
              boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
              width: 18,
              height: 18,
              borderRadius: 10
            },
            '& .MuiSwitch-track': {
              borderRadius: 24 / 2,
              opacity: 1,
              backgroundColor: '#8a9097',
              boxSizing: 'border-box'
            }
          }
        }
      }
    }
  };
};
var capitalizeText = function capitalizeText(name) {
  var arr = name.split(' ');
  for (var index = 0; index < arr.length; index++) {
    arr[index] = arr[index].charAt(0).toUpperCase() + arr[index].slice(1);
  }
  return arr.join(' ');
};
var handleErr = function handleErr(fieldName, value, errorDetails) {
  if (value) {
    errorDetails.push(fieldName);
  } else if (errorDetails.includes(fieldName)) {
    errorDetails.splice(errorDetails.findIndex(function (item) {
      return item === fieldName;
    }), 1);
  }
  return {
    errorDetails: errorDetails,
    value: value
  };
};
var bytesToSize = function bytesToSize(bytes, fractionDigits) {
  var sizes = ['Byte', 'KB', 'MB'];
  for (var _i = 0, _sizes = sizes; _i < _sizes.length; _i++) {
    var size = _sizes[_i];
    if (bytes <= 1024) {
      return bytes + ' ' + size;
    } else {
      bytes = parseFloat(String(bytes / 1024)).toFixed(fractionDigits);
    }
  }
  return bytes + ' P';
};
var cloneObject = function cloneObject(obj) {
  return JSON.parse(JSON.stringify(obj, function (key, value) {
    if (value instanceof RegExp) {
      return {
        source: new RegExp(value).source,
        flags: new RegExp(value).flags
      };
    }
    return value;
  }));
};
var getAxiosInstance = function getAxiosInstance(environment) {
  return axios.create({
    baseURL: getAPIBaseURL(environment)
  });
};
var generatePayloadObject = function generatePayloadObject(axiosInstance, clientToken, tenantId, role, requestorPayload, dcsJWTToken) {
  return {
    axiosInstance: axiosInstance,
    clientToken: clientToken,
    tenantId: tenantId,
    role: role,
    requestorPayload: requestorPayload,
    dcsJwtToken: dcsJWTToken
  };
};
var splitContactNumber = function splitContactNumber(number) {
  if (number !== null && number !== void 0 && number.includes('+')) return number === null || number === void 0 ? void 0 : number.split(/ (.*)/);else return [number];
};
var checkContactNumber = function checkContactNumber(splitContactNumber, contactNumber) {
  return !splitContactNumber ? contactNumber : splitContactNumber;
};
var splitContactNumberWithISDCode = function splitContactNumberWithISDCode(number, isdCode) {
  if (number !== null && number !== void 0 && number.includes('+')) return isdCode + ' ' + (number === null || number === void 0 ? void 0 : number.split(/ (.*)/)[1]);else return isdCode + ' ' + number;
};
var colSize = function colSize(size) {
  return size !== null && size !== void 0 ? size : 12;
};

/* 
the below methods are for tracking the dependant fields in the form on load of form if values
are already present for their respective parent fields.
*/
var checkForDependantAttributes = function checkForDependantAttributes(textFieldInput, displaySections, name, value) {
  var _textFieldInput$depen;
  if (textFieldInput !== null && textFieldInput !== void 0 && textFieldInput.dependantAttributes && (textFieldInput === null || textFieldInput === void 0 || (_textFieldInput$depen = textFieldInput.dependantAttributes) === null || _textFieldInput$depen === void 0 ? void 0 : _textFieldInput$depen.length) > 0 && (textFieldInput === null || textFieldInput === void 0 ? void 0 : textFieldInput.parentField) === name) {
    var _textFieldInput$depen2;
    textFieldInput === null || textFieldInput === void 0 || (_textFieldInput$depen2 = textFieldInput.dependantAttributes) === null || _textFieldInput$depen2 === void 0 || _textFieldInput$depen2.forEach(function (dependantItem) {
      if (textFieldInput.parentField) return modifyFields(textFieldInput === null || textFieldInput === void 0 ? void 0 : textFieldInput.parentField, value, dependantItem, false, '', displaySections);
    });
  }
};
var modifyChildDependantAttributes = function modifyChildDependantAttributes(displaySectionItem, displaySections, name, value) {
  var _displaySectionItem$f;
  displaySectionItem === null || displaySectionItem === void 0 || (_displaySectionItem$f = displaySectionItem.fields) === null || _displaySectionItem$f === void 0 || _displaySectionItem$f.forEach(function (fieldItem) {
    if (!Array.isArray(fieldItem)) {
      return checkForDependantAttributes(fieldItem, displaySections, name, value);
    } else {
      fieldItem === null || fieldItem === void 0 || fieldItem.forEach(function (innerFieldItem) {
        return checkForDependantAttributes(innerFieldItem, displaySections, name, value);
      });
    }
  });
  return displaySections;
};
var modifyDynamicFormAttributes = function modifyDynamicFormAttributes(displaySections, name, value) {
  var tempSections = displaySections;
  displaySections === null || displaySections === void 0 || displaySections.forEach(function (displayFieldItem) {
    modifyChildDependantAttributes(displayFieldItem, displaySections, name, value);
  });
  return tempSections;
};
export { getAPIBaseURL, getThemeOptions, isEmpty, getStorageLinks, getCountrySpecificFields, capitalizeText, modifyFields, handleErr, bytesToSize, getCountrySpecificDocuments, cloneObject, generatePayloadObject, modifyDynamicFormAttributes, getValidationMessage, getAxiosInstance, splitContactNumber, checkContactNumber, splitContactNumberWithISDCode, colSize };